function getSessionIdFromCookieOrStorage() {
  const cookieMatch = /(?:^|; )session_id=([^;]*)/.exec(document.cookie);
  const cookieSessionId = cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]).trim() : '';

  if (cookieSessionId && cookieSessionId !== 'undefined' && cookieSessionId !== 'null') {
    return cookieSessionId;
  }

  const storageSessionId = localStorage.getItem('session_id');
  if (storageSessionId && storageSessionId !== 'undefined' && storageSessionId !== 'null') {
    return storageSessionId;
  }

  return null;
}

function normalizeViewerToken(rawToken) {
  if (!rawToken) {
    return null;
  }

  let token = `${rawToken}`.trim();
  if (!token || token === 'undefined' || token === 'null') {
    return null;
  }

  // Accept backend responses like "token" or "Bearer token"
  if (token.startsWith('"') && token.endsWith('"')) {
    token = token.slice(1, -1).trim();
  }

  if (/^Bearer\s+/i.test(token)) {
    token = token.replace(/^Bearer\s+/i, '').trim();
  }

  return token || null;
}

/**
 * @param {Storage} storage
 * @param {string} key
 */
function readTokenFromStorage(storage, key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

/**
 * @param {Storage} storage
 * @param {string} key
 * @param {string} value
 */
function writeTokenToStorage(storage, key, value) {
  try {
    storage.setItem(key, value);
    return storage.getItem(key) === value;
  } catch {
    return false;
  }
}

function resolveSessionIdFromValidationPayload(data) {
  const candidates = [
    data?.session_id,
    data?.sessionId,
    data?.x_api_key,
    data?.xApiKey,
    data?.api_key,
    data?.apiKey,
  ];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    const normalized = `${candidate}`.trim();
    if (normalized && normalized !== 'undefined' && normalized !== 'null') {
      return normalized;
    }
  }

  return null;
}

export async function getValidateTicketToken(temporal_token, setData) {
  const API_URL_ENV = process.env.API_URL;
  const API_URL = `${API_URL_ENV}/tokens/validate-temporal-token`;

  console.log('Fetching token validation from API:', API_URL);

  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const body = JSON.stringify({
    temporal_token,
    viewer: 'CT',
  });

  const session_id = getSessionIdFromCookieOrStorage();

  if (session_id) {
    myHeaders.append('x-api-key', session_id);
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: myHeaders,
    body,
    credentials: 'include',
  });

  if (!response.ok) {
    let detail = 'Error validating token';

    try {
      const errorData = await response.json();
      detail = errorData?.detail || detail;
    } catch {
      // Response was not JSON.
    }

    throw new Error(detail);
  }

  const data = await response.json();

  if (typeof setData === 'function') {
    setData({
      patient: data?.patient,
      project: data?.project,
    });
  }

  const tokenViewer = normalizeViewerToken(data?.token_viewer);

  if (!tokenViewer) {
    throw new Error('Token validation succeeded but token_viewer is missing');
  }

  const persistedInSessionStorage = writeTokenToStorage(
    sessionStorage,
    'session_viewer',
    tokenViewer
  );
  const persistedInLocalStorage = writeTokenToStorage(localStorage, 'session_viewer', tokenViewer);

  const storedToken =
    readTokenFromStorage(sessionStorage, 'session_viewer') ||
    readTokenFromStorage(localStorage, 'session_viewer');

  if (!persistedInSessionStorage && !persistedInLocalStorage) {
    throw new Error(
      'session_viewer was not persisted in browser storage after temporal token validation'
    );
  }

  const sessionIdFromValidation = resolveSessionIdFromValidationPayload(data);

  if (sessionIdFromValidation) {
    localStorage.setItem('session_id', sessionIdFromValidation);
    console.log('session_id stored from temporal token validation response');
  }

  console.log('session_viewer stored successfully after temporal token validation', {
    hasToken: Boolean(storedToken),
    persistedInSessionStorage,
    persistedInLocalStorage,
  });

  return data;
}
